
export const GET_EXCLUSION_LIST = `
  query GetCompanyExclusionLists($exclusionListId:ID!) {
    companyExclusionLists(exclusionListId: $exclusionListId ){
      exclusionList {
        id
        name
        statementType
        description
        exclusionListType
        customers {
          id
          fullname
          petraId
        }
        companies {
          id
          name
          petraId
        }
      }
    }
  }
`;

export const ASSIGN_ENTITY_TO_EXCLUSION_LIST = `
  mutation AssignExclusionListToEntity($companyId: ID, $customerId: ID, $exclusionListId: ID!) {
    assignExclusionListToEntity(companyId: $companyId, customerId: $customerId, exclusionListId: $exclusionListId){
      company {
        id
        name
        petraId
      }
      customer{
        id
        fullname
        petraId
      }
      errors {
        property
        description
      }
    }
  }
`;

export const REMOVE_ENTITY_FROM_EXCLUSION_LIST = `
  mutation RemoveExclusionListFromEntity($companyId: ID, $customerId: ID, $exclusionListId: ID!) {
    removeExclusionListFromEntity(companyId: $companyId, customerId: $customerId, exclusionListId: $exclusionListId){
      company {
        id
        name
        petraId
      }
      customer{
        id
        fullname
        petraId
      }
      errors {
        property
        description
      }
    }
  }
`;

export const UPDATE_EXCLUSION_LIST = `
  mutation UpdateExclusionList($id: ID!, $name: String, $statementType: String, $exclusionListType: String, $description: String) {
    updateExclusionList(id: $id, name: $name, statementType: $statementType, exclusionListType: $exclusionListType, description: $description){
      exclusionList {
        id 
        name
        statementType
        description
        exclusionListType
        companies {
          id
          name
          petraId
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const SEARCH_COMPANY = `
query SearchCompany($q: String!, $page: ID!) {
  companySearch(q: $q, page: $page) {
    count
    results {
      id
      petraId
      name
      companyPhones {
        id
        phone {
          id
          number
          type
        }
        isPrimary
      }
      companyEmails {
        id
        isPrimary
        email {
          id
          address
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const SEARCH_CUSTOMER = `
query SearchCustomer($q: String!, $page: ID!) {
  customerSearch(q: $q, page: $page) {
    count
    results {
      id
      petraId
      fullname
      activeCustomerPhones {
        id
        phone {
          id
          number
          type
        }
        isPrimary
      }
      customerEmails {
        id
        isPrimary
        email {
          id
          address
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;